// extracted by mini-css-extract-plugin
export default {"root":"Bf8mlczkTrdgaqMLOnMP","label":"HLKkXQ7FHIN3bBHLNxB3","placeHolderShimmer":"r9E6nzrPL_Hj0eesvZZ6"};